import styles from './Slide.module.css'
import lgProtect from '../Img/Card/protect.png'
import lgTraffic from '../Img/Card/traffic.png'
import lgTether from '../Img/Card/tethet.png'
import lgUnlim from '../Img/Card/unlim.png'
import lgSelf from '../Img/Card/self.png'
import lgSms from '../Img/Card/sms.png'
import lgCall from '../Img/Card/imgCall.png'

import lpBeeline from '../Img/Card/logoBeeline.png'
import lpMegafon from '../Img/Card/logoMegafon.png'
import lpTele2 from '../Img/Card/logoTele2.png'
import lpYota from '../Img/Card/logoYota.png'


import imgCons from '../Img/Card/imgCons.png'

import snMessage from "../Img/Card/messager.png"
import snMail from "../Img/Card/mail.png"
import snSocial from "../Img/Card/social.png"
import snMap from "../Img/Card/map.png"
import snVideo from "../Img/Card/video.png"
import snPlane from "../Img/Card/plane.png"


import lgApMoney from "../Img/Card/apPrice.png"
import lgNoLock from "../Img/Card/nolock.png"
import lgMNP from "../Img/Card/mnp.png"
import lgPass from "../Img/Card/pass.png"

import lgSimYota from "../Img/Oper/sim_yota.png"
import lgSimMegafon from "../Img/Oper/sim_mega.png"
import lgSimMts from "../Img/Oper/sim_mts.png"
import lgSimRtk from "../Img/Oper/sim_rtk.png"
import lgSimBeeline from "../Img/Oper/sim_bee.png"
import lgSimT2 from "../Img/Oper/sim_t2.png"
import React, {useContext, useEffect, useRef, useState} from "react";
import {Link, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {ActionMessageInt, ReduxStateInt, setSlider} from "../Reducer/GlobalReducer";
import NoteItem from "../FormTemplate/NoteItem/NoteItem";
import ModalWindow from "../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../FormTemplate/InputItem/InputItem";
import WaitLoader from "../WaitLoader/WaitLoader";
import useApiQuery from "../ApiQuery/UseApiQuery";
import TarifConsult from "./TarifConsult/TarifConsult";
import ErrorLineItem, {ErrorLineItemRef} from "../FormTemplate/ErrorLineItem/ErrorLineItem";
import any = jasmine.any;
import {Subscription} from "rxjs";
import * as net from "net";


interface ICardItem {
    [key: string]: any
    tarifId:string
    bundleOne:{
        [key: string]: any
        regionMnpList: string

    }
    canSelfReg:boolean
    optList: string
    snList:string
    name:string
    operId:string
    useMNP:boolean


}

interface ISlideProps
{
    item:any,
    showConnect?:boolean
}
export default function Slide({item,showConnect}:ISlideProps) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()

    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })
    const subscriber = useRef<Subscription>()



    const couponCheckData = useRef<{
        coupon:string
    }>()
    const [ldrCouponCheck,rsCouponCheck,exCouponCheck] = useApiQuery("/tarif/coupon/check","post",couponCheckData);


    const sliderState = useSelector((state:ReduxStateInt)  => {return state.slider} )

    const blurErrorLine = useRef<ErrorLineItemRef>(null)

    const [blurCoupon, setBlurCoupon] = useState<string>("")

    const baseRegion = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })


    const [showConsultTitle, setShowConsultTitle] = useState(false)
    const [showConsult, setShowConsult] = useState(false)

    const [useMnp, setUseMnp] = useState(false)


    useEffect(()=>{
        if(subscriber.current)
        {
            try {
                subscriber.current?.unsubscribe()
            } catch (e) {

            }
        }
        //console.log(`Slider ${id.current} add subscriber`)
        subscriber.current = rxObserve.subscribe((e)=>messageMake(e))
        return ()=>{
            //console.log(`Slider ${id.current} remove subscriber`)
            if(subscriber.current)subscriber.current?.unsubscribe()
        }
    })


    useEffect(()=>{
        console.log("item", item)

        if(!item) return
        resolveMnpUse(item?.bundleOne?.regionMnpList)


    },[item])




    const messageMake = (message: ActionMessageInt) =>{

    }


    const resolveMnpUse = (mnpRegionList: string) => {
        //console.log(`resolveMnpUse ${mnpRegionList}`)
        if(! mnpRegionList) //Если нет никакой возможности mnp то не показываем вообще
        {
            setUseMnp(false)
            return;
        }
        if(item?.useMNP !== undefined && !item?.useMNP) //Если в самой карточке запрет на mnp не важно из каких регионов
        {
            setUseMnp(false)
            return;
        }
        if(!baseRegion?.isChanged) //Если есть какая либо возможность но регион не выбран показываем
        {
            setUseMnp(true)
            return;
        }

        const x  = mnpRegionList?.split(';')

        const match = x?.filter((item)=>{
            if(item?.match(/all/ui)) return true
            if(baseRegion?.isChanged)
            {
                const m1 = new RegExp("^"+baseRegion?.macroRegionId+"$","ui")
                const m2 = new RegExp("^"+baseRegion?.regionId+"$","ui")
                if(item?.match(m1) || item?.match(m2)) return  true

            }
            return  false

        })

        //console.log(`match`, match)
        setUseMnp( match?.length > 0)




    }


    const buildRangeLine = (_percent : number = 50, style: string)=>{
        const x = _percent < 100 ? _percent : 99
        return (
            <div className={styles.rlCont}>

                {x > 0 &&
                    <div className={[styles.rlUnit, style].join(' ')} style={{width: `${x}%`}}>

                    </div>
                }
            </div>
        )
    }






    const buildOptList = ()=>{


        const opt = item?.optList?.split(';')?.map((opt:string, key:number)=>{
            if(opt.match(/^pr$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={lgProtect}></img>
                        <span>Защита от подписок</span>
                    </div>
                )
            }
            if(opt.match(/^gb$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={lgTraffic}></img>
                        <span>Перенос остатков гигабайт</span>
                    </div>
                )
            }
            if(opt.match(/^gbm$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={lgTraffic}></img>
                        <span>Перенос остатков минут и гигабайт</span>
                    </div>
                )
            }
            if(opt.match(/^min$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={lgTraffic}></img>
                        <span>Перенос остатков минут</span>
                    </div>
                )
            }
            if(opt.match(/^tt$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={lgTether}></img>
                        <span>Раздача в модеме</span>
                    </div>
                )
            }
            if(opt.match(/^nl$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={lgNoLock}></img>
                        <span>Не блокируем при нуле</span>
                    </div>
                )
            }
            if(opt.match(/^my$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={lgPass}></img>
                        <span>Оформление на Вас</span>
                    </div>
                )
            }
            if(opt.match(/^rm$/ui))
            {
                return(
                    <div key={key} className={styles.optContainer}>
                        <img className={styles.optImage} src={snPlane}></img>
                        <span>Связь за границей</span>
                    </div>
                )
            }
            return null
        })

        return (
            <>
                {useMnp &&
                    <div  className={styles.optContainer}>
                        <img className={styles.optImage} src={lgMNP}></img>
                        <span>Переход со своим номером</span>
                    </div>
                }
                {item?.canSelfReg &&
                    <div  className={styles.optContainer}>
                        <img className={styles.optImage} src={lgSelf}></img>
                        <span>Доступна саморегистрация</span>
                    </div>
                }
                {opt}
            </>
        )

    }

    const buildUnlimOper= () =>{
        if(! item.optList) return null
        const opt = item?.optList.split(';').map((opt:string, key:number)=>{
            if(opt.match(/^un$/ui))
            {
                return(
                    <div key={key} className={styles.unlimOper}>
                        <img className={styles.optImage} src={lgUnlim}></img>
                        <span>безлимит на {item.operId}</span>
                    </div>
                )
            }
            return null
        })
        return opt

    }


    const buildUnlimList =()=>{
        if(! item.snList) return null
        const img = item.snList.split(';').map((opt:string,key:number)=>{

            if(opt.match(/^vd$/ui))
            {
                return(
                    <div key={key}>
                        <NoteItem text={"Видеосервисы"}>
                            <img key={key} className={styles.optImage} src={snVideo} alt={"video"}/>

                        </NoteItem>

                    </div>
                )
            }
            if(opt.match(/^ms$/ui))
            {
                return(
                    <div key={key}>
                        <NoteItem text={"Мессенджеры"}>
                            <img key={key} className={styles.optImage} src={snMessage} alt={"messenger"}></img>

                        </NoteItem>

                    </div>
                )
            }
            if(opt.match(/^ml$/ui))
            {
                return(
                    <div key={key}>
                        <NoteItem text={"Почта"}>
                            <img key={key} className={styles.optImage} src={snMail} alt={"mail"}></img>
                        </NoteItem>
                    </div>

                )
            }
            if(opt.match(/^sl$/ui))
            {
                return(
                    <div key={key}>
                        <NoteItem text={"Соц.сети"}>
                            <img key={key} className={styles.optImage} src={snSocial} alt={"social"}></img>
                        </NoteItem>
                    </div>
                )
            }
            if(opt.match(/^mp$/ui))
            {
                return(
                    <div key={key}>
                        <NoteItem text={"Навигация"}>
                            <img key={key} className={styles.optImage} src={snMap} alt={"nav"}></img>
                        </NoteItem>
                    </div>
                )
            }
            return null

        })
        if(! img.length) return null
        return (
            <>
                <div className={styles.optContainer}>
                    <span className={styles.marginRight}>Безлимит на :</span>
                    {img}
                </div>
            </>
        )

    }

    const getOperLogo = (operId: string)=>{

//        const [pic, setPic] = useState([lgSimMegafon,lgSimT2,lgSimYota,lgSimBeeline,lgSimMts,lgSimRtk])

        if(operId === undefined) return lpMegafon
        if(operId.match(/mts/ui)) return lgSimMts
        if(operId.match(/beeline/ui)) return lpBeeline
        if(operId.match(/rtk/ui)) return lgSimRtk
        if(operId.match(/megafon/ui)) return lpMegafon
        if(operId.match(/yota/ui)) return lpYota
        if(operId.match(/tele2/ui)) return lpTele2
        return lgSimMegafon
    }

    let lgSim = getOperLogo(item?.operId)



    const buildNetSection = (netPacket: number) =>{

        let netStyle = styles.netStyleMegafon
        while(1){
            if(item?.operId?.match(/beeline/ui)){
                netStyle = styles.netStyleBeeline
                break
            }
            if(item?.operId?.match(/tele2/ui)){
                netStyle = styles.netStyleTele2
                break
            }

            break
        }

        if(netPacket === 9999)
            return(
                <div className={styles.packetContainer}>
                    <div className={styles.pText}>
                        <span>Интернет</span>
                        <div className={styles.unSecTr}>
                            <img className={styles.optImage} src={lgUnlim} alt={"unlim"}></img>
                            <span className={styles.netUnlim}>{"безлимит"}</span>
                        </div>

                    </div>
                    {buildRangeLine(100, netStyle)}
                </div>
            )
        const limit = 200
        const xPercent = netPacket < limit ? (netPacket)/limit * 100 : 100
        return(
            <div className={styles.packetContainer}>
                <div className={styles.pText}>
                    <span>Интернет</span>
                    <span>{netPacket + " Гб"}</span>

                </div>
                {buildRangeLine(xPercent, netStyle)}
            </div>
        )
    }
//shoConnect если фалше то и карточку не блюрим это для кабинета
    const xBlur = item?.bundleOne?.blurMode === 1 && sliderState?.hideItem && showConnect


    const handleCoupon = ()=>{
        if(! blurCoupon) return;
        if(blurErrorLine?.current && blurCoupon?.length === 0)
        {
            blurErrorLine.current.show("Введите номер купона", true,5000)

            return
        }

        couponCheckData.current = {
            coupon: blurCoupon
        }
        exCouponCheck().then((e)=>{
            if(e?.success)
            {
                dispatch(setSlider({
                    ...sliderState,
                    hideItem: false,
                    softCoupon: blurCoupon
                }))
                return
            }
            if(blurErrorLine?.current)blurErrorLine?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 5000)

        })


    }


    const buildBlur = ()=>{
        if(!xBlur) return null
        //if(!showConnect)return null
        return(
            <div className={styles.blurItem}>
                <div className={styles.blurPattern}>
                    <div className={styles.blurLoaderCont}>
                            <WaitLoader loading={ldrCouponCheck} onlyLoading={true} api={rsCouponCheck}>

                            </WaitLoader>

                    </div>

                    <div className={styles.apContainer}>
                        <div className={[styles.operTitle, styles.blurOperTitel].join(' ')}>{item?.operOne?.name}</div>
                        <img src={lgApMoney} className={styles.apImage} alt={"price"}/>
                        <span className={styles.apVal}>{item?.apList[0]?.val}</span>
                        <div className={styles.blurApText}>
                            <span>руб./месяц</span>
                        </div>

                    </div>

                    <div className={styles.blurTitle}>Введите купон для просмотра</div>

                    <InputItem
                        val={blurCoupon}
                        mode={"ie"}
                        title={""}
                        titleShift={-4}
                        info={"Если у Вас есть купон введите его для просмотра тарифа"}
                        onChange={(e)=>setBlurCoupon(e?.trim())}
                        exitOnEnter={true}
                        onKeyEnter={()=>handleCoupon()}


                    />


                    <div className={styles.blurErrorLine}><ErrorLineItem ref={blurErrorLine}/></div>
                    <div className={styles.blurButton}>

                        <button type="button" className="btn btn-face "
                                onClick={()=>handleCoupon()}
                        >Просмотр</button>

                    </div>


                </div>
            </div>
        )
    }

    const buildTrafficLine = ()=>{
        if(xBlur) return null
        let netStyle = styles.packetStyleMegafon
        while(1){
            if(item?.operId?.match(/beeline/ui)){
                netStyle = styles.packetStyleBeeline
                break
            }
            if(item?.operId?.match(/tele2/ui)){
                netStyle = styles.packetStyleTele2
                break
            }
            if(item?.operId?.match(/yota/ui)){
                netStyle = styles.packetStyleYota
                break
            }

            break
        }


        const packet = item?.packetList[0]?.val
        const limit = 2000
        const xPercent = packet < limit ? (packet)/limit * 100 : 100


        return(
            <div className={styles.upBlock}>
                {buildNetSection(Number(item?.netList[0]?.val))}
                {(item.type === 0) && <div className={styles.packetContainer}>
                    <div className={styles.pText}>
                        <div className={styles.clCont}>
                            <span>Звонки</span>
                            <img src={lgCall} alt={"Звонки"}/>
                        </div>
                        <span>{item?.packetList[0]?.val+" минут"}</span>

                    </div>
                    {buildRangeLine(xPercent, netStyle)}

                    {buildUnlimOper()}
                </div>}

                {(item.type === 1) && <div className={styles.packetContainer}>
                    <div className={styles.pTextInt}>
                        <span>Тариф только для интернета</span>
                    </div>
                    <div className={styles.pText}>
                        <span>Звонки</span>
                        <span>{"0 минут"}</span>
                    </div>
                    {buildRangeLine(xPercent, netStyle)}
                </div>}
                <div className={styles.smsContainer}>
                    <img src={lgSms} alt={"СМС"}/>
                    <span>{item.smsCount+" "} СМС</span>
                </div>

            </div>
        )
    }

    const buildOrderLine =()=>{
        return (
            <div className={styles.actCont}>
                <div className={[styles.btnSelect, styles.btnActNew].join(' ')}
                     onClick={()=>{
                         if(xBlur) return
                         dispatch(setSlider({
                             dataCardItem: item,
                             selectedTarif: item?.tarifId
                         }))
                         navigate('/order')

                     }}>Подключить новый номер
                </div>
                {useMnp &&
                    <div className={[styles.btnSelect, styles.btnActMnp].join(' ')}
                         onClick={()=>{
                             if(xBlur) return
                             dispatch(setSlider({
                                 dataCardItem: item,
                                 selectedTarif: item?.tarifId
                             }))
                             navigate('/tarif/mnp')

                         }}>Перейти со своим номером
                    </div>


                }

            </div>
        )
    }


    const buildConsultLine = ()=>{
        if(!showConnect) return null
        return(
            <>
                {showConsult && <TarifConsult onClose={()=>setShowConsult(false)} tarifName={item?.name} operName={item?.operOne?.name}/>}

                <div className={styles.consCont}
                     onMouseOut={()=>setShowConsultTitle(false)}
                     onMouseOver={()=>setShowConsultTitle(true)}
                     onClick={()=>setShowConsult(true)}

                >
                    <img src={imgCons} alt={"consult"}/>
                    {showConsultTitle  &&<div className={styles.consTitle}>консультация</div>}
                </div>
            </>
        )
    }

    const buildConnectLine = () =>{
        if(!showConnect)return null
        return(
            <>
                {buildUnlimList()}
                <hr className={styles.hrStyle}></hr>

                {buildOptList()}
                <div style={{height:"100%"}}></div>

                <hr className={styles.hrStyle}></hr>

                <div className={styles.btnContainer}>
                    {buildOrderLine()}
                    <Link to={`/tarif/${item?.tarifId}`} className={styles.link}>
                        <div className={[styles.lineAbout].join(' ')}>
                            Детали тарифа
                        </div>
                    </Link>

                </div>

            </>

        )
    }


    const buildSlide = () =>{
        return (
                <div className={[styles.slide, !showConnect ? styles.shortCard : ""].join(' ')}>
                    {buildBlur()}
                    {buildConsultLine()}


                    <Link to={`/tarif/${item?.tarifId}`} className={styles.link}>
                        <div className={[styles.header,  styles.sm  ].join(' ')}>{item.name}
                            <div className={styles.simImageCon}>
                                <img className={styles.simImage} src={lgSim} alt={"sim"}/>
                            </div>

                        </div>
                    </Link>

                    <div className={styles.apContainer}>
                        <div className={styles.operTitle}>{item?.operOne?.name}</div>
                        <img src={lgApMoney} className={styles.apImage} alt={"pay"}/>
                        <span className={styles.apVal}>{item?.apList[0]?.val}</span>
                        <div className={styles.apText}>
                            <span>руб./месяц</span>
                        </div>

                    </div>
                    {buildTrafficLine()}

                    {buildConnectLine()}




                </div>
            );

    }



    if(!Array.isArray(item?.packetList) || !Array.isArray(item?.apList) || !Array.isArray(item?.netList))return null
    return (

            buildSlide()

    )
}


